import React from 'react';
import * as styles from './styles.scss';

const Price = ({
    className,
    formatPrice,
    translate,
    price: {
        minimum_price: {
            regular_price,
            final_price,
            discount: {
                percent_off,
                amount_off,
            } = {},
        } = {},
    } = {},
    comparisonUnit,
    comparisonQty,
}) => (
    <div className={`${styles.wrapper}${className ? ` ${className}` : ''}`}>
        <div>
            {
                !!final_price && !!percent_off &&
                <span className={styles.price}>
                    {formatPrice(final_price)}
                </span>
            }
            {
                !!regular_price &&
                <span className={!!final_price && !!percent_off ? styles.throw : styles.price}>
                    {formatPrice(regular_price)}
                </span>
            }
        </div>
        {
            (!!amount_off || comparisonUnit) &&
            <div className={styles.options}>
                {
                    !!amount_off &&
                    <div className={styles.amount}>
                        <span className={styles.sale}>
                            {translate('Sale')}
                        </span>
                        <span className={styles.discount}>
                            {formatPrice({currency: final_price.currency, value: amount_off})}
                        </span>
                    </div>
                }
                {
                    !!comparisonUnit &&
                    <div className={styles.comparison}>
                        {`${formatPrice({
                            currency: regular_price.currency,
                            value: Math.round((regular_price.value / comparisonQty) * 100) / 100
                        })} per ${comparisonUnit}`}
                    </div>
                }
            </div>
        }
    </div>
);

export default Price;
